// import { MessagesSubscriptionsOrganisationTeam } from '@/dotnet-client'
import { createTableColumn, TableCellLayout, TableColumnDefinition } from '@fluentui/react-components'
import { PeopleTeam24Regular } from '@fluentui/react-icons'
import { RowActionsMenu } from './RowActionsMenu'
import { MessagesSubscriptionsOrganisationTeam } from '@/dotnet-client'

export const orgTeamsColumns: TableColumnDefinition<MessagesSubscriptionsOrganisationTeam>[] = [
  createTableColumn<MessagesSubscriptionsOrganisationTeam>({
    columnId: 'name',
    compare: (a, b) => {
      return a.name.localeCompare(b.name)
    },
    renderHeaderCell: () => {
      return 'Team'
    },
    renderCell: (item) => {
      return (
        <TableCellLayout media={<PeopleTeam24Regular color={'#D04A02'} />}>
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              paddingTop: '.5rem',
              paddingBottom: '.5rem',
              gap: '5px',
              lineHeight: '1rem',
            }}
          >
            <span style={{ fontSize: '16px' }}>{item.name}</span>
            <span style={{ color: '#979797', fontSize: 'small' }}>{item.description}</span>
            <span style={{ color: '#979797', fontSize: 'small' }}>{item.organisation ?? ''}</span>
          </div>
        </TableCellLayout>
      )
    },
  }),
  createTableColumn<MessagesSubscriptionsOrganisationTeam>({
    columnId: 'application',
    compare: (a, b) => {
      return (a.application || '').localeCompare(b.application || '')
    },
    renderHeaderCell: () => {
      return 'Application'
    },
    renderCell: (item) => {
      return <TableCellLayout>{item.application}</TableCellLayout>
    },
  }),
  createTableColumn<MessagesSubscriptionsOrganisationTeam>({
    columnId: 'linkedProjectCount',
    compare: (a, b) => {
      return a.linkedProjectCount - b.linkedProjectCount
    },
    renderHeaderCell: () => {
      return 'Projects'
    },
    renderCell: (item) => {
      return <TableCellLayout>{item.linkedProjectCount.toString()}</TableCellLayout>
    },
  }),
  createTableColumn<MessagesSubscriptionsOrganisationTeam>({
    columnId: 'activeLinkedProjectCount',
    compare: (a, b) => {
      return a.activeLinkedProjectCount - b.activeLinkedProjectCount
    },
    renderHeaderCell: () => {
      return 'Active projects'
    },
    renderCell: (item) => {
      return <TableCellLayout>{item.activeLinkedProjectCount.toString()}</TableCellLayout>
    },
  }),
  createTableColumn<MessagesSubscriptionsOrganisationTeam>({
    columnId: 'linkedUserCount',
    compare: (a, b) => {
      return a.linkedUserCount - b.linkedUserCount
    },
    renderHeaderCell: () => {
      return 'Users'
    },
    renderCell: (item) => {
      return <TableCellLayout>{item.linkedUserCount.toString()}</TableCellLayout>
    },
  }),
  createTableColumn<MessagesSubscriptionsOrganisationTeam>({
    columnId: 'linkedRoleCount',
    compare: (a, b) => {
      return a.linkedRoleCount - b.linkedRoleCount
    },
    renderHeaderCell: () => {
      return 'Roles'
    },
    renderCell: (item) => {
      return <TableCellLayout>{item.linkedRoleCount.toString()}</TableCellLayout>
    },
  }),
  createTableColumn<MessagesSubscriptionsOrganisationTeam>({
    columnId: 'actions',
    renderHeaderCell: () => {
      return 'Actions'
    },
    renderCell: (item) => {
      return <RowActionsMenu team={item} />
    },
  }),
]
